import React, { useEffect, useState } from 'react';
import { Field, Label, Spinner, Tag, TagPicker, TagPickerControl, TagPickerGroup, TagPickerInput, TagPickerList, TagPickerOnOptionSelectData, TagPickerOption, TagPickerProps } from '@fluentui/react-components';

import { connect } from 'react-redux';

// models
import { ProtocolVisit } from '../../../../models/Entities/Protocols/ProtocolVisit';

// component functions
import * as ownFunctions from './ProtocolVisitSelector.Functions';

const ProtocolVisitSelectorComponent = (props: ownFunctions.Props) => {

    const [internalSelection, setInternalSelection] = useState<ProtocolVisit[] | ProtocolVisit | undefined>();
    const [selectedOptions, setSelectedOptions] = useState<ProtocolVisit[]>([]);
    const excludedVisitIds = new Set(props.ExcludedVisitIds || []);

    useEffect(() => {
        var axuOptions = props.Visits.filter((visit: ProtocolVisit) => props.SelectedVisitIds?.includes(visit.crossVersionId));
        setSelectedOptions(axuOptions);
    }, [props.SelectedVisitIds]);

    useEffect(() => {
        props.GetMedicalProtocolById(props.ProtocolId);
    }, [props.ProtocolId]);

    useEffect(() => {
        if (props.Protocol?.id) {
            props.GetVisitsByProtocolId(props.Protocol?.id);
        }
    }, [props.Protocol?.id]);

    const onOptionSelect: TagPickerProps["onOptionSelect"] = (e, data: TagPickerOnOptionSelectData) => {
        if (data.value === "no-options") {
            setSelectedOptions([]);
            setInternalSelection([]);
            props.onSelectedVisit([]);
            return;
        }

        if (props.MultiselectEnable) {

            var axuOptions = props.Visits.filter((visit: ProtocolVisit) => data.selectedOptions.includes(visit.crossVersionId.toString()));
            setSelectedOptions(axuOptions);
            setInternalSelection(axuOptions as ProtocolVisit[]);
            props.onSelectedVisit(axuOptions);
        } else {
            if (data.selectedOptions.includes(data.value)) {
                // Nueva selección: reemplazar con solo este item
                const axuOption = props.Visits.find((visit: ProtocolVisit) => visit.crossVersionId.toString() === data.value);
                setSelectedOptions(axuOption ? [axuOption] : []);
                setInternalSelection(axuOption);
                props.onSelectedVisit(axuOption);
            } else {
                // Deselección (X presionado): limpiar
                setSelectedOptions([]);
                setInternalSelection(undefined);
                props.onSelectedVisit(undefined);
            }
        }
    };

    const tagPickerOptions = props.Visits?.filter((visit: ProtocolVisit) => {
        const isSelected = selectedOptions.some((selected) => selected.crossVersionId === visit.crossVersionId);
        const isExcluded = excludedVisitIds.has(visit.crossVersionId);
        return !isSelected && !isExcluded;
    });

    return (
        <>
            <Field label="Seleccione una visita del flowchart">
                <div onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}>
                    <TagPicker
                        onOptionSelect={onOptionSelect}
                        selectedOptions={selectedOptions.map((visit) => visit.crossVersionId.toString())}
                    >
                        <TagPickerControl  expandIcon={(props.isLoadingProtocol || props.isLoadingProtocol) ? <Spinner size="extra-tiny" /> : undefined}>
                            <TagPickerGroup aria-label="Visitas Seleccionadas">
                                {selectedOptions.map((visit: ProtocolVisit) => (
                                    <Tag
                                        key={visit.crossVersionId}
                                        shape="rounded"
                                        value={visit.crossVersionId.toString()}
                                    >
                                        {visit.title}
                                    </Tag>
                                ))}
                            </TagPickerGroup>
                            <TagPickerInput aria-label="Seleccione una visita" />
                        </TagPickerControl>
                        <TagPickerList>
                            {tagPickerOptions?.length > 0 ? (
                                tagPickerOptions?.map((visit: ProtocolVisit) => (
                                    <TagPickerOption
                                        value={visit.crossVersionId.toString()}
                                        key={visit.crossVersionId}
                                    >
                                        {visit.title}
                                    </TagPickerOption>
                                ))
                            ) : (
                                <TagPickerOption value="no-options">
                                    No hay visitas disponibles
                                </TagPickerOption>
                            )}
                        </TagPickerList>
                    </TagPicker>
                </div>
            </Field>
        </>
    );
};

export default connect(
    ownFunctions.mapStateToProps,
    ownFunctions.mapDispatchToProps
)(ProtocolVisitSelectorComponent as any);